<template>
  <v-chip
    :color="
      value
        ? value.toLowerCase() == 'active'
          ? 'warning'
          : value.toLowerCase() == 'draft'
          ? 'grey'
          : value.toLowerCase() == 'inactive'
          ? 'red'
          : 'green'
        : 'grey'
    "
    v-if="value"
    class="white--text"
    disabled
  >
    {{ value }}
  </v-chip>
</template>

<script>
export default {
  props: ['value']
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/template/generalixwarroom/GameSetting/CampaignStatus.vue